import template from './cardRequestFailure.html';
import controller from './cardRequestFailure.controller';
import './cardRequestFailure.scss';

let cardRequestFailureComponent = {
  restrict: 'E',
  bindings: {
    days: '<',
    errorMsg: '<',
    onClose: '&',
  },
  template,
  controller,
};

export default cardRequestFailureComponent;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/components/userCardList/userCardRow/homeCard/cardRequestFailure/cardRequestFailure.component.js